<h2 mat-dialog-title>
  {{ title }}

  @if (date) {
    <span class="json-date flex items-center">
      {{ date | cDate: 'L LTS' }}

      @if (dateDetailsLink) {
        <a [routerLink]="dateDetailsLink" target="_blank" rel="noopener" class="leading-none ml-2">
          <mat-icon>open_in_new</mat-icon>
        </a>
      }
    </span>
  }

  <mat-button-toggle-group [(ngModel)]="viewMode" class="margin-left">
    <mat-button-toggle value="tree">Tree</mat-button-toggle>
    <mat-button-toggle value="json">JSON</mat-button-toggle>
  </mat-button-toggle-group>
</h2>

<mat-dialog-content>
  @if (json) {
    @if (viewMode === 'json') {
      <sc-json-highlight [json]="json"></sc-json-highlight>
    } @else if (viewMode === 'tree') {
      <button mat-stroked-button class="mb-2" (click)="expandToggle()">
        @if (expanded) {
          Collapse all
        } @else {
          Expand all
        }
      </button>

      <ngx-json-viewer #jsonViewer [json]="json" [expanded]="expanded"></ngx-json-viewer>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close type="button">
    {{ 'CLOSE' | translate }}
  </button>
</mat-dialog-actions>
